export const OPTIONS_TYPES = {
  boolean: 'boolean',
  number: 'number',
  string: 'string',
  array: 'array',
};

export const OPTIONS_TYPES_DEFINITION = {
  text_short: {
    properties: {
      required: {
        type: 'boolean',
        default: false,
      },
      isNumber: {
        type: 'boolean',
        default: false,
      },
    },
    required: ['required', 'isNumber'],
  },
  text_long: {
    properties: {
      required: {
        type: 'boolean',
        default: false,
      },
      minLength: {
        type: 'number',
        minimum: 0,
        default: 0,
      },
      maxLength: {
        type: 'number',
        minimum: 0,
        default: 0,
      },
    },
    required: ['required', 'minLength', 'maxLength'],
  },
  date: {
    properties: {
      required: {
        type: 'boolean',
        default: false,
      },
      includeDate: {
        type: 'boolean',
        default: true,
      },
      includeTime: {
        type: 'boolean',
        default: false,
      },
    },
    required: ['required', 'includeDate', 'includeTime'],
  },
  duration: {
    properties: {
      required: {
        type: 'boolean',
        default: false,
      },
      defaultUnit: {
        type: 'string',
        enum: [
          'years',
          'months',
          'weeks',
          'days',
          'hours',
          'minutes',
          'seconds',
        ],
        default: 'hours',
      },
    },
    required: ['required', 'defaultUnit'],
  },
  scale: {
    properties: {
      required: {
        type: 'boolean',
        default: false,
      },
      startNumber: {
        type: 'number',
        default: 0,
      },
      endNumber: {
        type: 'number',
        default: 100,
      },
      step: {
        type: 'number',
        minimum: 1,
        default: 1,
      },
      range: {
        type: 'boolean',
        default: false,
      },
    },
    required: ['required', 'startNumber', 'endNumber', 'step', 'range'],
  },
  list: {
    properties: {
      required: {
        type: 'boolean',
        default: false,
      },
      // items: {
      //   type: 'array',
      //   items: {
      //     type: 'object',
      //     properties: {
      //       id: {
      //         type: 'number'
      //       },
      //       value: {
      //         type: 'string'
      //       },
      //     },
      //   },
      //   default: [],
      // },
      selectMany: {
        type: 'boolean',
        default: false,
      },
    },
    required: ['required', 'items', 'next', 'selectMany'],
  },
  // location: {
  //     properties: {
  //         required: {
  //             type: 'boolean',
  //             default: false
  //         },
  //         captureUserLocation: {
  //             type: 'boolean',
  //             default: false
  //         },
  //     },
  //     required: ["required", "captureUserLocation"]
  // },
  // file: {
  //     properties: {
  //         required: {
  //             type: 'boolean',
  //             default: false
  //         },
  //         expectedFileCount: {
  //             type: 'number',
  //             minimum: 0,
  //             default: 0
  //         },
  //         expectedFileCountApproximation: {
  //             type: 'boolean',
  //             default: false
  //         },
  //     },
  //     required: ["required", "expectedFileCount", "expectedFileCountApproximation"]
  // },
  // reference_link: {
  //     properties: {
  //         required: {
  //             type: 'boolean',
  //             default: false
  //         },
  //         domainCollections: {
  //             type: 'array',
  //             items: {
  //                 type: 'string'
  //             },
  //             default: [],
  //         },
  //         selectMany: {
  //             type: 'boolean',
  //             default: false
  //         },
  //
  //     },
  //     required: ["required", "domainCollections", "selectMany"]
  // }
};



// WEBPACK FOOTER //
// ./src/js/forms/enums/OptionsTypes.js